import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';

// 이벤트 데이터 타입 정의
export interface DigitalCampParams {
  eventName: 'join' | 'adult_auth' | 'purchase';
  userIdx: number;
  transactionId: string;
}
export const useDigitalCamp = () => {
  const $ = _c(1);
  const initScript = _temp;
  const trackEvent = _temp2;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      initScript,
      trackEvent
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp() {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById("dcamp-common-script")) {
    return;
  }
  const script = document.createElement("script");
  script.id = "dcamp-common-script";
  script.src = "https://conv.digitalcamp.co.kr/mtk.php?175";
  script.async = true;
  document.head.appendChild(script);
}
function _temp2(t0) {
  const {
    eventName,
    userIdx,
    transactionId
  } = t0;
  if (typeof window === "undefined") {
    return;
  }
  let dcamp_elapsedTime = 0;
  const dcamp_interval = setInterval(() => {
    if (typeof window.dcampconv_175 === "function") {
      clearInterval(dcamp_interval);
      window.dcampconv_175(eventName, {
        user_idx: userIdx,
        transaction_id: transactionId
      });
    } else {
      dcamp_elapsedTime = dcamp_elapsedTime + 300;
      dcamp_elapsedTime;
      if (dcamp_elapsedTime >= 5000) {
        clearInterval(dcamp_interval);
        console.warn("DigitalCamp script load timeout.");
      }
    }
  }, 300);
}